import axios, { AxiosResponse } from 'axios';

export interface INovyUcet {
    identifikator: string;
    stat: string;
    typ: string;
    nazev?: string;
}

const novyUcetApi = async (data: INovyUcet) => {
    return axios({
        method: 'POST',
        url: 'Portal/Novyucet',
        data: data
    }).then((resp: AxiosResponse<{ iductu: number }>) => resp.data);
};

export const nazevSpolecnostiApi = async (ico: string) => {
    return axios({
        method: 'GET',
        url: 'Portal/Novyucet/Nazev',
        params: {
            stat: 'CZ',
            ico: ico
        }
    }).then((resp: AxiosResponse<{ nazev: string }>) => resp.data);
};

export default novyUcetApi;
